import NLS                  from "Dashboard/Core/NLS";
import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { ScheduleHoliday }  from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    sort      : {
        orderBy  : "time",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "SCHEDULE_HOLIDAY_LOADING" });
    },

    /**
     * Fetches the Schedule Holiday List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await ScheduleHoliday.getAll(params);
        data.sort = params;
        dispatch({ type : "SCHEDULE_HOLIDAY_LIST", data });
    },

    /**
     * Fetches a single Schedule Holiday
     * @param {Function} dispatch
     * @param {Number}   scheduleHolidayID
     * @returns {Promise}
     */
    async fetchElem(dispatch, scheduleHolidayID) {
        const data = await ScheduleHoliday.getOne({ scheduleHolidayID });
        dispatch({ type : "SCHEDULE_HOLIDAY_ELEM", data });
    },

    /**
     * Edits/Creates a Schedule Holiday
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return ScheduleHoliday.edit(data);
    },

    /**
     * Deletes a Schedule Holiday
     * @param {Function} dispatch
     * @param {Number}   scheduleHolidayID
     * @returns {Promise}
     */
    deleteElem(dispatch, scheduleHolidayID) {
        return ScheduleHoliday.delete({ scheduleHolidayID });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.monthName = NLS.get("DATE_MONTH_NAMES", elem.month);
    elem.yearText  = elem.year || NLS.get("GENERAL_ALL");
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "SCHEDULE_HOLIDAY_LIST", "SCHEDULE_HOLIDAY_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "SCHEDULE_HOLIDAY_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "SCHEDULE_HOLIDAY_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : Utils.parseList(action.data.list, parseElem),
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "SCHEDULE_HOLIDAY_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : parseElem(action.data.elem),
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
